import "./App.css";
import { useState } from "react";

function App() {
  const [phase, setPhase] = useState("A")
  const [inputValue, setInputValue] = useState("")
  const [inputError, setInputError] = useState(false);
  const [partBValue, setpartBValue] = useState("")
  const [partBError, setpartBError] = useState(false);
  const partBcontent = `
  import sys

class ChristmasGiftProtocol:
    def __init__(self):
        # ERROR LOG: "Data corruption detected in sector B."
        
        # -----------------------------------------------------------
        self.encrypted_packets = [84, 66, 53, 65, 61]
        # -----------------------------------------------------------
        
        self.decryption_keys = []

    def load_decryption_logic(self):
        """
        Generates a unique XOR key for each position in the packet.
        """

        for i in range(len(self.encrypted_packets)):
            self.decryption_keys.append(lambda byte: byte ^ i)

    def run_decrypt(self):
        self.load_decryption_logic()
        
        result = []
        try:
            for idx, byte in enumerate(self.encrypted_packets):
                # Apply the corresponding decoder to the byte
                decoder = self.decryption_keys[idx]
                decoded_char = chr(decoder(byte))
                result.append(decoded_char)
            
            print(f"Decrypting... Success?")
            print(f"OUTPUT: {''.join(result)}")
            
        except Exception as e:
            print(f"Critical Failure: {e}")

if __name__ == "__main__":
    print("Initializing Santa's Workshop v2.0...")
    gift = ChristmasGiftProtocol()
    gift.run_decrypt()
  `

  const handleButtonClick = (e) => {
    if (inputValue === "224ghostboob") {
      setPhase("A-pass")
      const blob = new Blob([partBcontent], { type: "text/plain" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "partB.py";
      a.click();

      URL.revokeObjectURL(url);
    } else {
      setInputError(true)
    }
  }
  const handleButtonBClick = (e) => {
    if (partBValue === "TC7B9") {
      setPhase("B-pass")
    } else {
      setpartBError(true)
    }
  }

  return (
    <div className="App barriecito-regular">
      <header className="App-header">
        <h1>
          Happy New Year!! 🎄🎅
          <br />
        </h1>
      </header>
      <div className="App-content barriecito-regular">{
        phase === "A" ? (
          <div className="barriecito-regular">
            <h2>Enter the password:</h2>
            <div className="App-content-input">
              <input value={inputValue} onChange={(e) => {
                setInputError(false)
                setInputValue(e.target.value)
              }
              } />
              <button onClick={handleButtonClick}>OK</button>
            </div>

            <h3>Hint: Our anniversary + Our first song + our special phrase :)</h3>
            {inputError && <p style={{ color: "maroon" }}>Sorry! Wrong! 😎</p>}
          </div>
        ) : phase === "A-pass" ? (<div>
          <h2>Success!!🥳</h2>
          <h2>Part A of the code is:</h2>
          <h1 className="barriecito-regular" style={{ fontWeight: "bold", fontSize: "32px" }}>XM5BR</h1>
          <h2>Now, a file has been downloaded. Continue to phase B!😈</h2>
          <h2>Good Luck, Hacker!👨‍💻</h2>
          <button className="App-button-B" onClick={() => setPhase("B")}>Continue</button>
        </div>) : phase === "B" ? (<div className="barriecito-regular">
          <h2>You must solve the bug in the downloaded python code!👀</h2>
          <h2>Enter part B:</h2>
          <div className="App-content-input">
            <input value={partBValue} onChange={(e) => {
              setpartBError(false)
              setpartBValue(e.target.value)
            }
            } />
            <button onClick={handleButtonBClick}>OK</button>
          </div>
          {partBError && <p style={{ color: "maroon" }}>Sorry! Wrong! ☹️</p>}
        </div>) : (<div>
          <h2>Congratulations!!🥳🎉</h2>
          <h2>You have successfully completed both phases!</h2>
          <h2>Now, find the last part!</h2>
          <h3>Hint: Merry Christmas!😌😉🎁</h3>
        </div>)
      }</div>
    </div>
  );
}

export default App;
